// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';
import { getIconPath } from '../../../../../utils';

const dropDownlist = css`
  position: absolute;
  width: ${(props) => (!props.spc ? 'calc(100% + 4px)' : '100%')};
  z-index: 1;
  padding-top: ${(props) => (!props.spc ? '2px' : '0')};
  margin-left: ${(props) => (!props.spc ? '-2px' : '0')};
  .dropdownUlBorder {
    border: 1px solid ${(props) => props.theme.colors.BORDER.NORMAL};
    background-color: ${(props) => props.theme.colors.WHITE};
  }

  .dropdownliBottomBorder {
    border-bottom: 1px solid ${(props) => props.theme.colors.PRIMARY.LIGHTGRAY};
    margin: 0 ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.SM} 0;
    cursor: pointer;
  }

  .dropdownDivOverFlow {
    overflow-y: auto;
    max-height: 230px;
  }

  .dropdownActiveClass {
    background-color: ${(props) =>
      props.theme.brandSpecificStyles.DROPDOWN_LIST.DROPDOWN_ACTIVE_CLASS_BACKGROUND_COLOR};
    position: relative;
    z-index: 2;
  }

  .dropdownActiveIcon {
    background-image: url(${(props) => getIconPath('active_icon', props)});
    background-repeat: no-repeat;
    position: absolute;
    top: 18%;
    right: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
  }

  .dropDownListwrapper {
    position: relative;
    padding-bottom: ${(props) => props.theme.spacing.LAYOUT_SPACING.LRG};
    border: 1px solid ${(props) => props.theme.colors.BORDER.NORMAL};
    background-color: ${(props) => props.theme.colors.WHITE};
  }

  .dropdownClassBtn {
    color: ${(props) => props.theme.colors.WHITE};
    background-color: ${(props) => props.theme.colors.PRIMARY.DARK};
  }

  .ulBorderWithLastRow {
    border-bottom: ${(props) => props.theme.colors.BORDER.NORMAL};
    width: 100%;
  }

  .ulBorderWithLastRow li:hover {
    background: ${(props) =>
      props.theme.brandSpecificStyles.DROPDOWN_LIST.UL_BORDER_WITH_LAST_ROW_BACKGROUND};
  }

  .ulBorderWithLastRow li:last-child div {
    position: absolute;
    bottom: 0;
    width: calc(100% - 24px);
    border-bottom: none;
  }

  .no-border {
    border-bottom: none;
  }

  .ulBorderWithLastRow li:last-child:hover {
    background: none;
  }
  ${(props) => (props.inheritedStyles ? props.inheritedStyles : '')};

  .dropdown--disabled {
    pointer-events: none;
  }
  .dropDownTop {
    background-image: linear-gradient(to bottom, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
    position: absolute;
    width: auto;
    height: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    z-index: 1;
    margin-left: 0;
    left: 0;
    right: 0;
  }
  .dropDownBottom {
    background-image: linear-gradient(to top, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
    position: absolute;
    width: auto;
    height: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    bottom: 57px;
    z-index: 1;
    margin-bottom: 6px;
    margin-left: 0;
    left: 0;
    right: 0;
  }
`;

export default dropDownlist;
